import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Box,
  Typography,
  Tooltip,
  Stack,
  Paper,
  Container,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fade,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ConstructionIcon from '@mui/icons-material/Construction';
import ExploreIcon from '@mui/icons-material/Explore';


function HomePage() {
  const navigate = useNavigate();
  const [aboutOpen, setAboutOpen] = useState(false);

  const handleOpenAbout = () => {
    setAboutOpen(true);
  };

  const handleCloseAbout = () => {
    setAboutOpen(false);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f5f7fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={4}
          sx={{
            p: 5,
            borderRadius: 3,
            textAlign: 'center',
            backgroundColor: 'white',
          }}
        >
           <IconButton 
            sx={{ position: 'absolute', top: 12, right: 12 }}
            onClick={handleOpenAbout}
            aria-label="About Spaces"
          >
            <InfoIcon color="action" />
          </IconButton>

          <Typography variant="h4" gutterBottom color="text.primary">
            Welcome, Space Explorer! 🚀
          </Typography>

          <Stack spacing={2} mt={4}>

            <Tooltip title="Craft your world from the ground up">
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => navigate('/custom-space')}
              >
                Customize Space
              </Button>
            </Tooltip>

            <Tooltip title="Discover spaces created by others">
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<ExploreIcon />}
                onClick={() => navigate('/explore')}
              >
                Explore Shared Spaces
              </Button>
            </Tooltip>

          </Stack>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom sx={{ mt: 3 }}>
            this is your Space, your mind's canvas 🧠
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          there are no limits, except those that you create 🫸🏼  🤔 👾 🦄  🫷🏼
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          spacing out is encouraged 🤯
          </Typography>



          <Tooltip title="Watch AI Arena">
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => window.open('https://www.youtube.com/watch?v=F918kMB0hdc', '_blank')}
              >
                AI Arena 🥊
              </Button>
            </Tooltip>
        </Paper>
      </Container>
      {/* About Dialog */}
            <Dialog
              open={aboutOpen}
              onClose={handleCloseAbout}
              TransitionComponent={Fade}
              maxWidth="sm"
            >
       <DialogTitle>
                What are Spaces?
              </DialogTitle>
              <DialogContent>
                <Typography paragraph>
                  <strong>Spaces</strong> are interactive, personalized canvases that you can customize and share publicly with others. Think of them as digital environments with unique personalities and purposes.
                </Typography>
                <Typography paragraph>
                  You can create Spaces for virtually anything: hosting viewing parties for TV shows, creating expert AI environments for grad school applications, building themed discussion forums, or crafting specialized knowledge hubs.
                </Typography>
                <Typography paragraph>
                  Once created, others can interact with your Space, engaging with the environment and content you've designed. Your Space becomes a living, shareable experience.
                </Typography>
                <Typography paragraph>
                  <strong>Choose your path:</strong>
                </Typography>
                <Typography paragraph sx={{ pl: 2 }}>
                  • <strong>Build a Space for Me:</strong> Our AI helps create a tailored Space based on your concept, handling the technical details automatically.
                </Typography>
                <Typography paragraph sx={{ pl: 2 }}>
                  • <strong>Custom Space:</strong> Design your Space from scratch, with complete creative control over every element and interaction.
                </Typography>
                <Typography paragraph sx={{ pl: 2 }}>
                  • <strong>Browse Spaces:</strong> Explore public Spaces created by others - join viewing parties, get expert advice, or find inspiration for your own creations.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseAbout}>Close</Button>
                <Button variant="contained" onClick={() => {
                  handleCloseAbout();
                  navigate('/build-space');
                }}>
                  Get Started
                </Button>
              </DialogActions>
            </Dialog>
    </Box>
  );
}
export default HomePage;